/**
 * Constants for HTML sanitization in task lists.
 * These are security-critical values that define what is allowed to pass through sanitization.
 */

/**
 * Allow list for class sanitization. Only these classes are preserved; all others are stripped.
 * This is more secure than a deny list because unknown classes are blocked by default.
 *
 * Security fix for HackerOne #3530628
 */
export const ALLOWED_CLASS_NAMES = new Set([
  // Core functionality
  'reference', // isConvertable() uses querySelectorAll('span.reference')
  // Emoji
  'emoji', // CSS styling for emoji images
  'g-emoji', // Custom emoji element
  // Math rendering
  'js-inline-math', // math-renderer isInline getter + CSS
  'js-display-math', // math-renderer isDisplay getter + CSS
  // Issue/PR links
  'issue-link', // Link styling
  'js-issue-link', // Hovercards
  'issue-shorthand', // #123 display
  // Mentions
  'user-mention', // @user hovercards
  'team-mention', // @org/team hovercards
  'js-team-mention', // @org/team hovercards (behavior class)
  'notranslate', // Prevent browser translation
  // Commit links
  'commit-link', // Commit SHA links with hovercards
  // State icons
  'octicon', // SVG icons
  'octicon-link', // Anchor link icon
  'open', // Open state
  'closed', // Closed state
  'merged', // Merged PR state
  'mr-1', // Icon margin
  'color-fg-muted', // Muted color
  'color-fg-open', // Open PR color
  'color-fg-done', // Merged PR color
  'color-fg-closed', // Closed PR color
  // Accessibility
  'sr-only', // Screen reader only text
  // Footnotes (inline references)
  'data-footnote-backref', // Footnote back-reference link
])

/**
 * Valid hovercard URL patterns - strict allowlist with full anchoring.
 * Patterns are anchored at start (^) and end ($) to prevent path traversal bypasses.
 * Query strings are NOT allowed.
 *
 * SECURITY: Do not remove the $ anchor - it prevents attacks like:
 *   /memexes/0/hovercard/../../../evil -> would resolve to /evil
 */
export const SAFE_HOVERCARD_URL_PATTERNS = [
  /^\/users\/[^/]+\/hovercard$/, // /users/monalisa/hovercard
  /^\/orgs\/[^/]+\/hovercard$/, // /orgs/github/hovercard
  /^\/orgs\/[^/]+\/teams\/[^/]+\/hovercard$/, // /orgs/github/teams/engineering/hovercard
  /^\/[^/]+\/[^/]+\/issues\/\d+\/hovercard$/, // /owner/repo/issues/123/hovercard
  /^\/[^/]+\/[^/]+\/pull\/\d+\/hovercard$/, // /owner/repo/pull/123/hovercard
  /^\/[^/]+\/[^/]+\/commit\/[a-fA-F0-9]+\/hovercard$/, // /owner/repo/commit/abc123/hovercard
  /^\/[^/]+\/[^/]+\/discussions\/\d+\/hovercard$/, // /owner/repo/discussions/123/hovercard
  /^\/copilot\/hovercard$/, // /copilot/hovercard
  /^\/memexes\/\d+\/hovercard$/, // /memexes/123/hovercard (projects)
]
